import firebase from "../../firebase";

export default function({
    officeId,
    name,
    lastName,
    initials,
    phoneNumber,
    soundId,
    passwordProtected,
    password,
    userId,
    bgColor,
    passwordNew,
    type
}) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingAdmin",
        funcName: "updateUser",
        data: {
            officeId,
            name,
            lastName,
            initials,
            phoneNumber,
            soundId,
            passwordProtected,
            password,
            userId,
            bgColor,
            passwordNew,
            type
        }
    });
}
